import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, tap } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DashbordService {
    private _crondata: BehaviorSubject<any> = new BehaviorSubject(null);

    constructor(
        private _httpClient: HttpClient,
    ) { }
    get crondata$(): Observable<any> {
        return this._crondata.asObservable();
    }

    dashboardDetails(): Observable<any> {
        return this._httpClient.get<any>(environment.apiBaseUrl + '/dashboard/get-dashboard-statistics-count');
    }
    getStatistics(): Observable<any> {
        return this._httpClient.get<any>(environment.apiBaseUrl + '/dashboard/get-statistics');
    }
    getTopSellingASINReport(sort = 'asin',
        order: 'asc' | 'desc' | '' = 'desc',
        search = '',): Observable<any> {
        return this._httpClient.get<any>(environment.apiBaseUrl + '/dashboard/top-selling-asin',
            {
                params: {
                    sortBy: `${sort}:${order || 'desc'}`,
                    search,
                },
            }
        );
    }
    getTopSellingSellerReport(sort = 'asin',
        order: 'asc' | 'desc' | '' = 'desc',
        search = '',): Observable<any> {
        return this._httpClient.get<any>(environment.apiBaseUrl + '/dashboard/top-selling-seller',
            {
                params: {
                    sortBy: `${sort}:${order || 'desc'}`,
                    search,
                },
            }
        );
    }

    topProductsGroupDetails(
        sort = '_id',
        order: 'asc' | 'desc' | '' = 'desc'
    ): Observable<any> {
        return this._httpClient.get<any>(environment.apiBaseUrl + '/dashboard/get-product-group-details'
            , { params: { sortBy: `${sort}:${order || 'desc'}`, }, }
        );
    }
    getCronLogs(): Observable<any> {
        return this._httpClient.get(environment.apiBaseUrl + '/dashboard/cron-logs').pipe(
            tap((response: any) => {
                this._crondata.next(response.data);
            })
        );
    }

    getAdminDashboardCount(): Observable<any> {
        return this._httpClient.get<any>(environment.apiBaseUrl + '/dashboard/get-admin-dashboard-count');
    }

    getAdminDashboardPropertyTypeAndCount(): Observable<any> {
        return this._httpClient.get<any>(environment.apiBaseUrl + '/dashboard/get-property-type-and-count-for-dashboard');
    }
}
